<template>
  <div>
    <div class="ui form">
      <h3 class="ui dividing header">Выбор учебного плана</h3>
      <div class="three fields">
        <div class="nine wide field">
          <label>Специальность</label>
          <select @change="getEduProf(programm.edu_prog)"
                  class="ui fluid search selection dropdown fullText"
                  name="edu_prog"
                  v-model="programm.edu_prog">
            <option value="">Выберите специальность</option>
            <option v-for="option in select_options.edu_progs" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="three wide field">
          <label>Год</label>
          <select @change="getCurriculum(programm.edu_prog, programm.year, programm.edu_prof)"
                  class="ui fluid search selection dropdown"
                  name="year"
                  v-model="programm.year">
            <option value="">Год учебного плана</option>
            <option v-for="option in select_options.years" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="nine wide field">
          <label>Профиль</label>
          <select @change="getCurriculum(programm.edu_prog, programm.year, programm.edu_prof)"
                  id="edu_prof" class="ui fluid search selection dropdown"
                  name="edu_prof"
                  v-model="programm.edu_prof">
            <option value="">Выберите профиль</option>
            <option v-for="option in select_options.edu_profs" :value="option.id" :key="option.id">
              {{ option.id1c }} {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <div class="two fields">
          <div class="twelve wide field">
            <label class="bold">Учебный план</label>
            <select id="curriculum"
                    @change="getDisciplines(programm.curriculum)"
                    class="ui fluid search selection dropdown"
                    name="curriculum"
                    v-model="programm.curriculum">
              <option value="">Учебный план</option>
              <option v-for="option in select_options.curriculum" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="six wide field">
            <label class="bold">Дисциплина</label>
            <select id="discipline"
                    @change="getMainInformation(programm.edu_prog, programm.edu_prof, programm.curriculum, programm.discipline)"
                    class="ui fluid search selection dropdown fullText"
                    name="discipline"
                    v-model="programm.discipline">
              <option value="">Дисциплина</option>
              <option v-for="option in select_options.disciplines" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="main_info.speciality_code.split('.')[1] === '02'">
        <div class="two fields">
          <div class="seven wide field">
            <label class="bold">Вид дисциплины</label>
            <select id="curriculum"
                    class="ui fluid search selection dropdown"
                    name="curriculum"
                    v-model="main_info.discipline_type">
              <option value="">Вид дисциплины</option>
              <option v-for="option in discipline_types">
                  {{ option }}
              </option>
            </select>
          </div>
          <div class="four wide field">
            <label class="bold">Индекс дисциплины</label>
            <input type="text" placeholder="Индекс" v-model="main_info.disciplines_index">
          </div>
        </div>
      </div>
    </div>
    <h3 class="ui dividing header">Использовать в качестве шаблона</h3>
    <div class="nine wide field">
      <label style="font-weight: bold">Заполнить на основании шаблона</label>
      <select @change="getRPD(programm.rpd_sample)"
              class="ui fluid search selection dropdown fullText"
              name="edu_prog"
              v-model="programm.rpd_sample">
        <option value="0">Без шаблона</option>
        <option v-for="option in select_options.rpd_samples" :value="option.id" :key="option.id">
          {{ option.name }}, Специальность: {{ option.speciality}}, {{option.year}}
        </option>
      </select>
    </div>
    <div class="ui form" id="main" v-if="main">
      <h3 class="ui dividing header">Основная информация</h3>
      <div id="basis">
        <div class="inline fields">
          <div class="five wide field">
            <div class="ui right pointing large label">
              РАБОЧАЯ ПРОГРАММА
            </div>
            <input type="text" placeholder="Дисциплина" v-model="main_info.discipline" disabled="true">
          </div>
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
            <div class="ui right pointing large label">
              Направление подготовки
            </div>
            <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
          </div>
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
            <div class="ui right pointing large label">
              Специальность
            </div>
            <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Квалификация выпускника
            </div>
            <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
          </div>
        </div>
        <div class="inline fields">
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
            <div class="ui right pointing large label">
              Профиль
            </div>
            <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
          </div>
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
            <div class="ui right pointing large label">
              Специализация
            </div>
            <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
          </div>
          <div class="three wide field">
            <div class="ui right pointing large label">
              Год набора
            </div>
            <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Форма обучения
            </div>
            <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
          </div>
        </div>
        <div class="ui equal width form">
          <div class="inline fields">
            <div class="three wide field">
              <div class="ui right pointing large label">
                Курс
              </div>
              <input type="text" placeholder="Курс" v-model="main_info.course" :disabled="main_info.speciality_code.split('.')[1] !== '02'">
            </div>
            <div class="three wide field" v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
              <div class="ui right pointing large label">
                Семестр
              </div>
              <input type="text" placeholder="Семестр" v-model="main_info.period" :disabled="main_info.speciality_code.split('.')[1] !== '02'">
            </div>
            <div class="three wide field" v-if="main_info.credit.length">
              <div class="ui right pointing large label">
                Зачет
              </div>
              <input type="text" placeholder="Зачет" v-model="main_info.credit" :disabled="main_info.speciality_code.split('.')[1] !== '02'">
            </div>
            <div class="three wide field" v-if="main_info.credit_mark.length">
              <div class="ui right pointing large label">
                Зачет с оценкой
              </div>
              <input type="text" placeholder="Зачет" v-model="main_info.credit_mark" :disabled="main_info.speciality_code.split('.')[1] !== '02'">
            </div>
            <div class="three wide field" v-if="main_info.exam.length">
              <div class="ui right pointing large label">
                Экзамен
              </div>
              <input type="text" placeholder="Экзамен" v-model="main_info.exam" :disabled="main_info.speciality_code.split('.')[1] !== '02'">
            </div>
          </div>
          <div class="inline fields">
            <div class="four wide field">
              <div class="ui right pointing large label">
                Трудоемкость
              </div>
              <input type="text" placeholder="Трудоемкость" v-model="main_info.load.hour">
            </div>
            <div class="three wide field">
              <div class="ui right pointing large label">
                ЗЕТ
              </div>
              <input type="text" placeholder="ЗЕТ" v-model="main_info.load.zet">
            </div>
          </div>
          <div class="inline fields">
            <div class="four wide field">
              <div class="ui right pointing large label">
                И.О.Фамилия
              </div>
              <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
            </div>
            <div class="four wide field">
              <div class="ui right pointing large label">
                Должность
              </div>
              <input type="text" placeholder="Должность" v-model="main_info.creator.position">
            </div>
            <div class="four wide field">
              <div class="ui right pointing large label">
                Ученая степень
              </div>
              <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title">
            </div>
          </div>
        </div>
        <table class="ui red celled table">
          <thead>
          <tr class="active">
            <th>Семестр</th>
            <th>Нагрузка</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "load in TotalLoad">
            <td width="70%" >{{ load.key }}</td>
            <td>
              <div class="ui list" v-for = "type in load.value">
                <div class="item">{{type.load}} - {{type.value}}</div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="two fields">
          <div class="six wide field">
            <label>Выпускающая кафедра</label>
            <select class="ui fluid search selection dropdown"
                    name="grad_dep"
                    v-model="main_info.grad_dep">
              <option value="">Выпускающая кафедра</option>
              <option v-for="option in select_options.departments" :value="option.name" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="six wide field">
            <label>Заведующий выпускающей кафедры</label>
            <div class="ui input">
              <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="provisor">
            </div>
          </div>
        </div>
        <div class="three fields">
          <div class="five wide field">
            <label>Факультет</label>
            <div class="ui input">
              <input type="text" placeholder="Факультет" v-model="main_info.facility">
            </div>
          </div>
          <div class="five wide field">
            <label>Обеспечивающая кафедра</label>
            <div class="ui input">
              <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department">
            </div>
          </div>
          <div class="five wide field">
            <label>
              Заведующий кафедрой
            </label>
            <div class="ui input">
              <input type="text" placeholder="Заведующий кафедрой" name="dep_manager" v-model="main_info.dep_manager">
            </div>
          </div>
        </div>
        <div class="two fields">
          <div class="four wide field">
            <label>Дата заседания кафедры</label>
            <div class="ui input">
              <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date">
            </div>
          </div>
          <div class="two wide field">
            <label>Протокол №</label>
            <div class="ui input">
              <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num">
            </div>
          </div>
        </div>
        <div><textarea rows="2" v-model="main_info.basis"></textarea></div>
        <div class="two fields">
          <div class="four wide field">
            <label>Дата утверждения приказа</label>
            <div class="ui input">
              <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date">
            </div>
          </div>
          <div class="two wide field">
            <label>№ Приказа</label>
            <div class="ui input">
              <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num">
            </div>
          </div>
        </div>
      </div>
      <div id="1.Цели">
        <div v-if="main_info.speciality_code.split('.')[1] === '02'" >
          <h3 class="ui dividing header">1. ОБЛАСТЬ ПРИМЕНЕНИЯ ПРОГРАММЫ</h3>
          <h4>Рабочая программа {{main_info.discipline}} являетсяч частью ППССЗ в соотвествии с ФГОС по специальности {{main_info.speciality}}</h4>
          <h4>Дисциплина требует предварительного изучения</h4>
          <vue-editor v-model="text_info.purpose" :editor-toolbar="customToolbar"/>
          <h4>Дисциплина предшествует изучению (предназначена для создания теоретической базы знаний у студентов для изучения)</h4>
          <vue-editor v-model="text_info.task" :editor-toolbar="customToolbar"/>
        </div>
        <div v-else>
          <h3 class="ui dividing header">1. ЦЕЛИ И ЗАДАЧИ ОСВОЕНИЯ ДИСЦИПЛИНЫ</h3>
          <div>
            <h4>1.1 Цель дисциплины</h4>
            <vue-editor v-model="text_info.purpose" :editor-toolbar="customToolbar"/>
            <h4>1.2 Задачи дисциплины</h4>
            <vue-editor v-model="text_info.task" :editor-toolbar="customToolbar"/>
          </div>
        </div>
      </div>
      <div id="2.Место дисциплины">
        <h3 class="ui dividing header">2. МЕСТО ДИСЦИПЛИНЫ В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ</h3>
        <vue-editor v-if="main_info.speciality_code.split('.')[1] !== '02'" v-model="text_info.place" :editor-toolbar="customToolbar"/>
        <div v-if="main_info.speciality_code.split('.')[1] === '02'" >
          <h4>Из общего объема часов {{ (parseFloat(times["Практические занятия"].need) + parseFloat(times["Лабораторные занятия"].need)) }} часов являются практической подготовкой, которая представлена в программе в виде практических занятий</h4>
          <h4>Воспитание реализуется в программе в единстве урочной и внеурочной деятельности. В рамках каждого занятия планируются воспитательные цели, направленные на формирование профессионала в соответствии с квалификацией {{main_info.quality}} и воспитание соответствующих качеств личности.</h4>
          <h4>При планировании и проведении занятий планируются активные и интерактивные формы учебной деятельности:</h4>
          <div class="ui toggle checkbox">
            <input type="checkbox" name="Деловые игры" v-model="spo_comp.business">
            <label>Деловые игры</label>
          </div>
          <div class="ui toggle checkbox">
            <input type="checkbox" name="Ролевые игры" v-model="spo_comp.role">
            <label>Ролевые игры</label>
          </div>
          <div class="ui toggle checkbox">
            <input type="checkbox" name="Разбор ситуаций" v-model="spo_comp.situation">
            <label>Разбор ситуаций</label>
          </div>
          <div class="ui toggle checkbox">
            <input type="checkbox" name="Компьютерные симуляции" v-model="spo_comp.computer">
            <label>Компьютерные симуляции</label>
          </div>
          <h4>Дисциплина реализуется с использованием технологии электронного обучения. Дистанционные образовательные технологии могут быть использованы для всех видов занятий при необходимости (погодные условия, санитарноэпидемиологические требования, режим чрезвычайной ситуации, военные действия и т.д.)</h4>
        </div>
      </div>
      <div id="3. Компетенции">
        <h3 v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7" class="ui dividing header">3. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ (МОДУЛЯ) И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ</h3>
        <div v-if="main_info.speciality_code.split('.')[1] === '02'">
          <div v-if="main_info.discipline_type === 'Профессиональная дисциплина' || main_info.discipline_type === 'МДК' || main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика'">
            <h4>3.1 Общие компетенции</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Код</div></th>
                <th width="30%"><div class="headTable">Наименование общих компетенции</div></th>
                <th width="50%" colspan="2"><div class="headTable">Наименование индикатора достижения общей компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpd_competitions.UK">
                <td>
                  <select id="UKcompetition" class="ui fluid search selection dropdown"
                          name="UKcompetition"
                          v-model="comp.info">
                    <option value="">Выберите компетенцию</option>
                    <option v-for="option in UK" :value="option" :key="option.id">
                      {{ option.code }} {{ option.desc }}
                    </option>
                  </select>
                </td>
                <td>
                  {{ comp.info.desc }}
                </td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelUKCompetition(rpd_competitions.UK.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="4">
                  <button class="ui right floated small button positive" v-on:click="AddUKCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <h4>3.2 Професиональные компетенции и индикаторы их достижения</h4>
            <table class="ui basic celled table" v-if="OPK.length">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Код</div></th>
                <th width="30%"><div class="headTable">Наименование профессиональной компетенции</div></th>
                <th width="50%" colspan="2"><div class="headTable">Наименование индикатора достижения профессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpd_competitions.OPK_cat">
                <td>
                  <select id="OPKCatcompetition" class="ui fluid search selection dropdown"
                          name="OPKCatcompetition"
                          v-model="comp.info">
                    <option value="">Выберите компетенцию</option>
                    <option v-for="option in OPK" :value="option" :key="option.id">
                      {{ option.code }} {{ option.desc }}
                    </option>
                  </select>
                </td>
                <td>{{ comp.info.desc }}</td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelOPKCatCompetition(rpd_competitions.OPK_cat.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="4">
                  <button class="ui right floated small button positive" v-on:click="AddOPKCatCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <table class="ui basic celled table" v-if="!OPK.length">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpd_competitions.OPK">
                <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование общепрофессиональной компетенции" v-model="comp.name"></textarea></div></td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelOPKCompetition(rpd_competitions.OPK.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="3">
                  <button class="ui right floated small button positive" v-on:click="AddOPKCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <h5 class="ui dividing header">Уметь </h5>
            <vue-editor v-model="spo_comp.able" :editor-toolbar="customToolbar"/>
            <h5 class="ui dividing header">Знать </h5>
            <vue-editor v-model="spo_comp.know" :editor-toolbar="customToolbar"/>
            <h5 v-if="main_info.discipline_type ==='МДК' || main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика'" class="ui dividing header">Иметь практическое применение </h5>
            <vue-editor v-if="main_info.discipline_type ==='МДК' || main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика'" v-model="spo_comp.own" :editor-toolbar="customToolbar"/>
          </div>
          <div v-if="main_info.discipline_type === 'Общеобразовательная дисциплина'">
            <vue-editor v-model="spo_comp.general" :editor-toolbar="customToolbar"/>
          </div>
        </div>
        <div v-else-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
          <h4>3.1 Универсальные компетенции и индикаторы их достижения</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
              <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
              <th width="40%" colspan="2"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpd_competitions.UK">
              <td>{{comp.info.cat}}</td>
              <td>
                <select id="UKcompetition" class="ui fluid search selection dropdown"
                        name="UKcompetition"
                        v-model="comp.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in UK" :value="option" :key="option.id">
                    {{ option.code }} {{ option.desc }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ comp.info.code }} {{ comp.info.desc }}
                </div>
              </td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelUKCompetition(rpd_competitions.UK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="4">
                <button class="ui right floated small button positive" v-on:click="AddUKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.2 Общепрофессиональные компетенции и индикаторы их достижения</h4>
          <table class="ui basic celled table" v-if="OPK.length">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
              <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
              <th width="40%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpd_competitions.OPK_cat">
              <td>{{comp.info.cat}}</td>
              <td>
                <select id="OPKCatcompetition" class="ui fluid search selection dropdown"
                        name="OPKCatcompetition"
                        v-model="comp.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in OPK" :value="option" :key="option.id">
                    {{ option.code }} {{ option.desc }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ comp.info.code }} {{ comp.info.desc }}
                </div>
              </td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelOPKCatCompetition(rpd_competitions.OPK_cat.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="4">
                <button class="ui right floated small button positive" v-on:click="AddOPKCatCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <table class="ui basic celled table" v-if="!OPK.length">
            <thead>
            <tr class="active">
              <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
              <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpd_competitions.OPK">
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование общепрофессиональной компетенции" v-model="comp.name"></textarea></div></td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelOPKCompetition(rpd_competitions.OPK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddOPKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
              <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpd_competitions.PK">
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование профессиональной компетенции" v-model="comp.name"></textarea></div></td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelPKCompetition(rpd_competitions.PK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddPKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.4 Дополнительные профессиональные компетенции</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
              <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpd_competitions.DPK">
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование дополнительной профессиональной компетенции" v-model="comp.name"></textarea></div></td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDPKCompetition(rpd_competitions.DPK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDPKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div id="4. Структура">
        <h3 class="ui dividing header">4. СТРУКТУРА ДИСЦИПЛИНЫ (МОДУЛЯ)</h3>
        <div class="ui warning message" style="display: block">
          <div class="header">
            Дробные числа пишутся через ТОЧКУ
          </div>
        </div>
        <div v-if="main_info.speciality_code.split('.')[1] === '02'">
          Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов
          <div class="ui basic segment" style="overflow-x: scroll;">
            <table class="ui basic celled table" cellpadding="0" cellspacing="0">
              <thead>
              <tr class="active">
                <th rowspan="2" width="2%"><div class="headTable">№ п/п</div></th>
                <th rowspan="2" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
                <th rowspan="2" width="2%"><div class="verticalText">Семестр</div></th>
                <th :colspan="8" width="18%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
                <th rowspan="2" width="5%"><div class="headTableInt">Экзамен</div></th>
                <th rowspan="2" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
                <th rowspan="2" colspan="2" width="20%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
              </tr>
              <tr>
                <th width="3%"><div class="headTable">Л</div></th>
                <th width="3%"><div class="headTable">ПЗ</div></th>
                <th width="3%"><div class="headTable">ЛЗ</div></th>
                <th width="3%"><div class="headTable">У</div></th>
                <th width="3%"><div class="headTable">С</div></th>
                <th width="3%" height="200px"><div class="verticalText">Курсовой проект/работа</div></th>
                <th width="3%"><div class="verticalText">КТО</div></th>
                <th width="3%"><div class="verticalText">Консультации</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "theme in o_themes">
                <td width="2%"><div class="ui transparent input"><input @change="sortThemes" style="width:100%;" type="text" placeholder="Семестр" v-model="theme.num"></div></td>
                <td><div class="ui form"><textarea @change="ChangeThemeName(themes.indexOf(theme), theme.name)" rows="2" type="text" placeholder="Название" v-model="theme.name"></textarea></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Семестр" v-model="theme.period"></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Л" v-model="theme.lecture" v-bind:disabled='!times["Лекционные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ПЗ" v-model="theme.practice" v-bind:disabled='!times["Практические занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ЛЗ" v-model="theme.laboratory" v-bind:disabled='!times["Лабораторные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Уроки" v-model="theme.lesson" v-bind:disabled='!times["Уроки"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="С" v-model="theme.seminar" v-bind:disabled='!times["Семинарские занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Курсовой" v-model="theme.ikr" v-bind:disabled='!times["Иная контактная работа"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="КТО" v-model="theme.kto" v-bind:disabled='!times["Контактные часы на теоретическое обучение"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Консультации" v-model="theme.ke" v-bind:disabled='!times["Контактные часы на экзамен"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Экзамен" v-model="theme.control" v-bind:disabled='!times.Экзамен.used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Самостоятельная работа" v-model="theme.indep_work" v-bind:disabled='!times["Самостоятельная работа"].used'></div></td>
                <td><div class="ui form"><textarea style="min-width:200px;" rows="2" type="text" placeholder="Формы текущего контроля" v-model="theme.control_form"></textarea></div></td>
                <td width="2%"><button class="mini ui icon button red stub" v-on:click="DelTheme(themes.indexOf(theme))"><i class="trash icon"></i></button></td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td> {{o_lectureTime}} ({{times["Лекционные занятия"].need}}) </td>
                <td> {{o_practiceTime}} ({{times["Практические занятия"].need}}) </td>
                <td> {{o_laboratoryTime}} ({{times["Лабораторные занятия"].need}}) </td>
                <td> {{o_lessonTime}} ({{times["Уроки"].need}}) </td>
                <td> {{o_seminarTime}} ({{times["Семинарские занятия"].need}}) </td>
                <td> {{o_ikrTime}} ({{times["Иная контактная работа"].need}}) </td>
                <td> {{o_ktoTime}} ({{times["Контактные часы на теоретическое обучение"].need}}) </td>
                <td> {{o_keTime}} ({{times["Контактные часы на экзамен"].need}}) </td>
                <td> {{o_controlTime}} ({{times.Экзамен.need}}) </td>
                <td> {{o_indepTime}} ({{times["Самостоятельная работа"].need}}) </td>
                <td colspan="2"></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th :colspan="table_size[2]">
                  <button class="ui right floated mini button positive" v-on:click="AddTheme">
                    <i class="add icon"></i>
                    Добавить тему
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div v-else-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
          Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов
          <div class="ui basic segment" style="overflow-x: scroll;">
            <table class="ui basic celled table" cellpadding="0" cellspacing="0">
              <thead>
              <tr class="active">
                <th rowspan="3" width="2%"><div class="headTable">№ п/п</div></th>
                <th rowspan="3" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
                <th rowspan="3" width="2%"><div class="verticalText">Семестр</div></th>
                <th :colspan="table_size[1]" width="18%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
                <th rowspan="3" width="5%"><div class="headTableInt">Контроль (в академических часах)</div></th>
                <th rowspan="3" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
                <th rowspan="3" colspan="2" width="30%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
              </tr>
              <tr>
                <th width="3%" :colspan="table_size[0]"><div class="headTable">Л</div></th>
                <th width="3%" :colspan="table_size[0]"><div class="headTable">ПЗ</div></th>
                <th width="3%" :colspan="table_size[0]"><div class="headTable">ЛР</div></th>
                <th width="3%" rowspan="2"><div class="verticalText">ИКР</div></th>
                <th width="3%" rowspan="2"><div class="verticalText">КТО</div></th>
                <th width="3%" rowspan="2"><div class="verticalText">КЭ</div></th>
              </tr>
              <tr>
                <th width="3%"><div class="verticalText">всего</div></th>
                <th width="3%"><div class="verticalText">в виде ПП</div></th>
                <th width="3%"><div class="verticalText">всего</div></th>
                <th width="3%"><div class="verticalText">в виде ПП</div></th>
                <th width="3%"><div class="verticalText">всего</div></th>
                <th width="3%"><div class="verticalText">в виде ПП</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "theme in o_themes">
                <td width="2%"><div class="ui transparent input"><input @change="sortThemes" style="width:100%;" type="text" placeholder="Семестр" v-model="theme.num"></div></td>
                <td><div class="ui form"><textarea @change="ChangeThemeName(themes.indexOf(theme), theme.name)" rows="2" type="text" placeholder="Название" v-model="theme.name"></textarea></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Семестр" v-model="theme.period"></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Л" v-model="theme.lecture" v-bind:disabled='!times["Лекционные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Л" v-model="theme.lecture_pp" v-bind:disabled='!times["Лекционные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ПЗ" v-model="theme.practice" v-bind:disabled='!times["Практические занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ПЗ" v-model="theme.practice_pp" v-bind:disabled='!times["Практические занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ЛР" v-model="theme.laboratory" v-bind:disabled='!times["Лабораторные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ЛР" v-model="theme.laboratory_pp" v-bind:disabled='!times["Лабораторные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ИКР" v-model="theme.ikr" v-bind:disabled='!times["Иная контактная работа"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="КТО" v-model="theme.kto" v-bind:disabled='!times["Контактные часы на теоретическое обучение"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="КЭ" v-model="theme.ke" v-bind:disabled='!times["Контактные часы на экзамен"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Контроль" v-model="theme.control" v-bind:disabled='!times.Экзамен.used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Самостоятельная работа" v-model="theme.indep_work" v-bind:disabled='!times["Самостоятельная работа"].used'></div></td>
                <td><div class="ui form"><textarea style="min-width:200px;" rows="2" type="text" placeholder="Формы текущего контроля" v-model="theme.control_form"></textarea></div></td>
                <td width="2%"><button class="mini ui icon button red stub" v-on:click="DelTheme(themes.indexOf(theme))"><i class="trash icon"></i></button></td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td :colspan="table_size[0]"> {{o_lectureTime}} ({{times["Лекционные занятия"].need}}) </td>
                <td :colspan="table_size[0]"> {{o_practiceTime}} ({{times["Практические занятия"].need}}) </td>
                <td :colspan="table_size[0]" > {{o_laboratoryTime}} ({{times["Лабораторные занятия"].need}}) </td>
                <td> {{o_ikrTime}} ({{times["Иная контактная работа"].need}}) </td>
                <td> {{o_ktoTime}} ({{times["Контактные часы на теоретическое обучение"].need}}) </td>
                <td> {{o_keTime}} ({{times["Контактные часы на экзамен"].need}}) </td>
                <td> {{o_controlTime}} ({{times.Экзамен.need}}) </td>
                <td> {{o_indepTime}} ({{times["Самостоятельная работа"].need}}) </td>
                <td colspan="2"></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th :colspan="table_size[2]">
                  <button class="ui right floated mini button positive" v-on:click="AddTheme">
                    <i class="add icon"></i>
                    Добавить тему
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div v-else>
          Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов
          <div class="ui basic segment" style="overflow-x: scroll;">
            <table class="ui basic celled table" cellpadding="0" cellspacing="0">
              <thead>
              <tr class="active">
                <th rowspan="2" width="2%"><div class="headTable">№ п/п</div></th>
                <th rowspan="2" width="20%"><div class="headTable">Тема (раздел) дисциплины</div></th>
                <th rowspan="2" width="5%"><div class="verticalText">Год обучения</div></th>
                <th colspan="3" width="38%"><div class="headTable">Виды контактной работы, включая самостоятельную работу и трудоемкость (з.е)</div></th>
                <th rowspan="2" colspan="2" width="30%"><div class="headTable">Формы текущего контроля успеваемости (по семестрам) Форма промежуточной аттестации (по семестрам)</div></th>
              </tr>
              <tr>
                <th width="3%" ><div class="headTable">Л</div></th>
                <th width="3%" ><div class="headTable">ПЗ</div></th>
                <th width="3%" ><div class="headTable">СР</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "theme in o_themes">
                <td width="2%"><div class="ui transparent input"><input @change="sortThemes" style="width:100%;" type="text" placeholder="Семестр" v-model="theme.num"></div></td>
                <td><div class="ui form"><textarea @change="ChangeThemeName(themes.indexOf(theme), theme.name)" rows="2" type="text" placeholder="Название" v-model="theme.name"></textarea></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Год обучения" v-model="theme.period"></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Л" v-model="theme.lecture" v-bind:disabled='!times["Лекционные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ПЗ" v-model="theme.practice" v-bind:disabled='!times["Практические занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="СР" v-model="theme.indep_work" v-bind:disabled='!times["Самостоятельная работа"].used'></div></td>
                <td><div class="ui form"><textarea style="min-width:200px;" rows="2" type="text" placeholder="Формы текущего контроля" v-model="theme.control_form"></textarea></div></td>
                <td width="2%"><button class="mini ui icon button red stub" v-on:click="DelTheme(themes.indexOf(theme))"><i class="trash icon"></i></button></td>
              </tr>
              <tr>
                <td colspan="6"></td>
                <td colspan="2" v-if="main_info.credit.length"> Зачет </td>
                <td colspan="2" v-if="main_info.exam.length"> Экзамен - {{times.Экзамен.need}} </td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td > {{o_lectureTime}} ({{times["Лекционные занятия"].need}}) </td>
                <td> {{o_practiceTime}} ({{times["Практические занятия"].need}}) </td>
                <td> {{o_indepTime}} ({{times["Самостоятельная работа"].need}}) </td>
                <td colspan="2"></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="8">
                  <button class="ui right floated mini button positive" v-on:click="AddTheme">
                    <i class="add icon"></i>
                    Добавить тему
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div id="5. Содержание (лекции, практики, лабы)">
        <h3 class="ui dividing header">5. СОДЕРЖАНИЕ ДИСЦИПЛИНЫ (МОДУЛЯ)</h3>
        <div>
          <h4>5.1 Лекции</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
              <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
              <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "lec in o_lectures">
              <td>{{o_lectures.indexOf(lec) + 1}}</td>
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="lec.lecture_name"></textarea></div></td>
              <td><vue-editor v-model="lec.lec_content_old" :editor-toolbar="customContentToolbar"/></td>
            </tr>
            </tbody>
          </table>
          <h4>5.2 Практические занятия</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
              <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
              <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "prac in o_practice">
              <td colspan="3">
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th colspan="3" width="5%">{{prac.practice_name}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "work in prac.practice_work">
                    <td width="30%"><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.work_name"></textarea></div></td>
                    <td width="68%"><vue-editor v-model="work.content" :editor-toolbar="customContentToolbar"/></td>
                    <td width="2%">
                      <button class="ui icon button red stub" v-on:click="DelPractice(themes.indexOf(prac), prac.practice_work.indexOf(work))"><i class="trash icon"></i></button>
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th colspan="3">
                      <button class="ui right floated small button positive" v-on:click="AddPractice(themes.indexOf(prac))">
                        <i class="add icon"></i>
                        Добавить практику
                      </button>
                    </th>
                  </tr>
                  </tfoot>
                </table>
              </td>
            </tr>
            </tbody>
          </table>
          <h4>5.3 Лабораторные работы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
              <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
              <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "lab in o_laboratory">
              <td colspan="3">
                <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                    <th colspan="3" width="5%">{{lab.laboratory_name}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "work in lab.laboratory_work">
                    <td width="30%"><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.work_name"></textarea></div></td>
                    <td width="68%"><vue-editor v-model="work.content" :editor-toolbar="customContentToolbar"/></td>
                    <td width="2%">
                      <button class="ui icon button red stub" v-on:click="DelLaboratory(themes.indexOf(lab), lab.laboratory_work.indexOf(work))"><i class="trash icon"></i></button>
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th colspan="3">
                      <button class="ui right floated small button positive" v-on:click="AddLaboratory(themes.indexOf(lab))">
                        <i class="add icon"></i>
                        Добавить лабораторную работу
                      </button>
                    </th>
                  </tr>
                  </tfoot>
                </table>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="main_info.speciality_code.split('.')[1] === '02'">
            <h4>5.4 Уроки</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "les in o_lesson">
                <td>{{o_lesson.indexOf(les) + 1}}</td>
                <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="les.lesson_name"></textarea></div></td>
                <td><vue-editor v-model="les.les_content_old" :editor-toolbar="customContentToolbar"/></td>
              </tr>
              </tbody>
            </table>
            <h4>5.5 Семинарские занятия</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "sem in o_seminar">
                <td>{{o_seminar.indexOf(sem) + 1}}</td>
                <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="sem.seminar_name"></textarea></div></td>
                <td><vue-editor v-model="sem.sem_content_old" :editor-toolbar="customContentToolbar"/></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div id="6. Самостоятельные">
        <h3 class="ui dividing header">6. САМОСТОЯТЕЛЬНАЯ РАБОТА</h3>
        <table class="ui basic celled table">
          <thead>
          <tr class="active">
            <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
            <th rowspan="2" width="20%"><div class="headTable">Наименование темы (раздела)</div></th>
            <th rowspan="2" width="65%"><div class="headTable">Форма (вид) самостоятельной работы</div></th>
            <th rowspan="2" width="10%"><div class="headTable">Трудоемкость в академических часах</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "work in o_indepWork">
            <td>{{o_indepWork.indexOf(work) + 1}}</td>
            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.indep_work_name"></textarea></div></td>
            <td><vue-editor v-model="work.indep_content_old" :editor-toolbar="customContentToolbar"/></td>
            <td>{{work.indep_work}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div id="7. Образовательные технологии" v-if="main_info.speciality_code.split('.')[1] !== '02'">
        <h3 class="ui dividing header">7. ОБРАЗОВАТЕЛЬНЫЕ ТЕХНОЛОГИИ</h3>
        <vue-editor v-model="text_info.technology" :editor-toolbar="customToolbar"/>
<!--        <table class="ui basic celled table" v-if="main_info.speciality_code.split('.')[1] === '02'">-->
<!--          <thead>-->
<!--          <tr class="active">-->
<!--            <th width="28%"><div class="headTable">Формы/Методы</div></th>-->
<!--            <th width="40%"><div class="headTable">лекционные занятия</div></th>-->
<!--            <th width="42%" colspan="2"><div class="headTable">практические/лабораторные/семинарские занятия</div></th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr v-for = "form in forms">-->
<!--            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Формы/Методы" v-model="form.name"></textarea></div></td>-->
<!--            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Формы/Методы" v-model="form.lec"></textarea></div></td>-->
<!--            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Формы/Методы" v-model="form.prac"></textarea></div></td>-->
<!--            <td width="2%">-->
<!--              <button class="ui icon button red stub" v-on:click="DelForms(forms.indexOf(form))"><i class="trash icon"></i></button>-->
<!--            </td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--          <tfoot>-->
<!--          <tr>-->
<!--            <th colspan="4">-->
<!--              <button class="ui right floated small button positive" v-on:click="AddForms">-->
<!--                <i class="add icon"></i>-->
<!--                Добавить компетенцию-->
<!--              </button>-->
<!--            </th>-->
<!--          </tr>-->
<!--          </tfoot>-->
<!--        </table>-->
      </div>
      <div id="8. Оценочные средства">
        <h3 class="ui dividing header">8. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ</h3>
        <table class="ui basic celled table" v-if="main_info.speciality_code.split('.')[1] === '02' && (main_info.discipline_type === 'Профессиональная дисциплина' || main_info.discipline_type === 'МДК' || main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика')">
          <thead>
          <tr class="active">
            <th width="40%"><div class="headTable">Результаты (освоенные профессиональные компетенции)</div></th>
            <th width="60%"><div class="headTable">Формы и методы контроля и оценки</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "option in rpd_competitions.UK">
            <td>{{ option.info.code }} {{ option.info.desc }}</td>
            <td><div class="ui form"><textarea rows="5" type="text" placeholder="Контроль" v-model="option.control"></textarea></div></td>
          </tr>
          <tr v-for = "option in rpd_competitions.OPK_cat">
            <td>{{ option.info.code }} {{ option.info.desc }}</td>
            <td><div class="ui form"><textarea rows="5" type="text" placeholder="Контроль" v-model="option.control"></textarea></div></td>
          </tr>
          </tbody>
        </table>
        <table class="ui basic celled table" v-else-if="main_info.speciality_code.split('.')[1] === '02' && main_info.discipline_type === 'Общеобразовательная дисциплина'">
          <thead>
          <tr class="active">
            <th width="60%"><div class="headTable">Результаты (освоенные профессиональные компетенции)</div></th>
            <th width="40%" colspan="2"><div class="headTable">Формы и методы контроля и оценки</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "control in spo_controls">
            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Формы/Методы" v-model="control.name"></textarea></div></td>
            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Формы/Методы" v-model="control.lec"></textarea></div></td>
            <td width="2%">
              <button class="ui icon button red stub" v-on:click="DelControls(spo_controls.indexOf(control))"><i class="trash icon"></i></button>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="3">
              <button class="ui right floated small button positive" v-on:click="AddControls">
                <i class="add icon"></i>
                Добавить контроль
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <vue-editor v-model="text_info.eval_tool" :editor-toolbar="customToolbar"/>
      </div>
      <div id="9. Учебно-методическое обеспечение">
        <h3 class="ui dividing header">9. УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ</h3>
        <div>
          <h4>9.a) литература</h4>
          <vue-editor v-model="text_info.literature" :editor-toolbar="customToolbar"/>
          <h4>9.б) программное обеспечение и Интернет ресурсы</h4>
          <h4>Программное обеспечение</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                <select id="software" class="ui fluid search selection dropdown"
                        name="software"
                        v-model="soft.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in select_options.software" :value="option" :key="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                    {{ soft.info.name }}
                </div>
              </td>
              <td>
                {{ soft.info.license }}
              </td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelSoftware(software.indexOf(soft))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddSoftware">
                  <i class="add icon"></i>
                  Добавить программное обеспечение
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>Интернет ресурсы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "res in resources">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="res.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="res.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelResources(resources.indexOf(res))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddResources">
                  <i class="add icon"></i>
                  Добавить Интернет ресурс
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>9.в) профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="db.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="db.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDataBases(data_bases.indexOf(db))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDataBases">
                  <i class="add icon"></i>
                  Добавить справочную систему
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div id="10. МТО">
        <h3 class="ui dividing header">10. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ ДИСЦИПЛИНЫ</h3>
        <vue-editor v-model="text_info.mto" :editor-toolbar="customToolbar"/>
      </div>
      <div id="Заочка" v-if="z_part">
        <div v-if="!has_z_part" class="inline fields">
          <div class="ui fitted toggle checkbox">
            <input @change="genZPart" type="checkbox" v-model="has_z_part">
            <label></label>
          </div>
          <div class="ui big green label">Создать приложение для заочной формы</div>
        </div>
        <div v-if="has_z_part">
          <h3 class="ui dividing header">ПРИЛОЖЕНИЕ К РАБОЧЕЙ ПРОГРАММЕ</h3>
          <div class="ui warning message" style="display: block">
            <div class="header">
              Дробные числа пишутся через ТОЧКУ
            </div>
          </div>
          <p>В соответствии с учебным планом для заочной формы обучения предусмотрено</p>
          <p v-if="z_control.used">Экзамен {{z_control.period.join()}} сем, {{z_control.input}} акад. часа</p>
          <p v-if="z_times.Зачет.used">Зачет {{z_times.Зачет.period.join()}} сем, {{z_times.Зачет.input}} акад. часа</p>
          <p v-if="z_times['Зачет с оценкой'].used">Зачет с оценкой {{z_times['Зачет с оценкой'].period.join()}} сем, {{z_times['Зачет с оценкой'].input}} акад. часа</p>
          <p v-if="z_lectureTime !== 0">Лекции {{z_lectureTime}} акад. часа</p>
          <p v-if="z_practiceTime !== 0">Практические занятия {{z_practiceTime}} акад. часа</p>
          <p v-if="z_laboratoryTime !== 0">Лабораторные работы {{z_laboratoryTime}} акад. часа</p>
          <p v-if="z_ikrTime !== 0">ИКР {{z_ikrTime}} акад. часа</p>
          <p v-if="z_indepTime !== 0">Самостоятельная работа {{z_indepTime}} акад. часа</p>
          <p>Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов</p>
          <h4>СТРУКТУРА ДИСЦИПЛИНЫ</h4>
          <div class="ui basic segment" style="overflow-x: scroll;">
            <table class="ui basic celled table" cellpadding="0" cellspacing="0">
              <thead>
              <tr class="active">
                <th rowspan="3" width="2%"><div class="headTable">№ п/п</div></th>
                <th rowspan="3" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
                <th rowspan="3" width="2%"><div class="verticalText">Семестр</div></th>
                <th colspan="9" width="18%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
                <th rowspan="3" width="5%"><div class="headTableInt">Контроль (в академических часах)</div></th>
                <th rowspan="3" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
                <th rowspan="3" colspan="2" width="30%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
              </tr>
              <tr>
                <th width="3%" colspan="2"><div class="headTable">Л</div></th>
                <th width="3%" colspan="2"><div class="headTable">ПЗ</div></th>
                <th width="3%" colspan="2"><div class="headTable">ЛР</div></th>
                <th width="3%" rowspan="2"><div class="verticalText">ИКР</div></th>
                <th width="3%" rowspan="2"><div class="verticalText">КТО</div></th>
                <th width="3%" rowspan="2"><div class="verticalText">КЭ</div></th>
              </tr>
              <tr>
                <th width="3%"><div class="verticalText">всего</div></th>
                <th width="3%"><div class="verticalText">в виде ПП</div></th>
                <th width="3%"><div class="verticalText">всего</div></th>
                <th width="3%"><div class="verticalText">в виде ПП</div></th>
                <th width="3%"><div class="verticalText">всего</div></th>
                <th width="3%"><div class="verticalText">в виде ПП</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "theme in z_themes">
                <td><div class="ui transparent input"><input @change="sortThemes" style="width:100%;" type="text" placeholder="№" v-model="theme.num"></div></td>
                <td><div class="ui form"><textarea @change="ChangeThemeName(themes.indexOf(theme), theme.name)" rows="2" type="text" placeholder="Название" v-model="theme.name"></textarea></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Семестр" v-model="theme.period"></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Л" v-model="theme.lecture" v-bind:disabled='!times["Лекционные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Л" v-model="theme.lecture_pp" v-bind:disabled='!times["Лекционные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ПЗ" v-model="theme.practice" v-bind:disabled='!times["Практические занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ПЗ" v-model="theme.practice_pp" v-bind:disabled='!times["Практические занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ЛР" v-model="theme.laboratory" v-bind:disabled='!times["Лабораторные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ЛР" v-model="theme.laboratory_pp" v-bind:disabled='!times["Лабораторные занятия"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="ИКР" v-model="theme.ikr" v-bind:disabled='!times["Иная контактная работа"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="КТО" v-model="theme.kto" v-bind:disabled='!times["Контактные часы на теоретическое обучение"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="КЭ" v-model="theme.ke" v-bind:disabled='!times["Контактные часы на экзамен"].used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Контроль" v-model="theme.control" v-bind:disabled='!times.Экзамен.used'></div></td>
                <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Самостоятельная работа" v-model="theme.indep_work" v-bind:disabled='!times["Самостоятельная работа"].used'></div></td>
                <td><div class="ui form"><textarea style="min-width:200px;" rows="2" type="text" placeholder="Формы текущего контроля" v-model="theme.control_form"></textarea></div></td>
                <td width="2%"><button class="mini ui icon button red stub" v-on:click="DelTheme(themes.indexOf(theme))"><i class="trash icon"></i></button></td>
              </tr>
              <tr>
                <td colspan="3"></td>
                <td colspan="2"> {{z_lectureTime}} </td>
                <td colspan="2"> {{z_practiceTime}} </td>
                <td colspan="2" > {{z_laboratoryTime}} </td>
                <td> {{z_ikrTime}} </td>
                <td> {{z_ktoTime}} </td>
                <td> {{z_keTime}} </td>
                <td> {{z_controlTime}} </td>
                <td> {{z_indepTime}} </td>
                <td colspan="2"></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="16">
                  <button class="ui right floated mini button positive" v-on:click="AddZTheme">
                    <i class="add icon"></i>
                    Добавить тему
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
          <h4>САМОСТОЯТЕЛЬНАЯ РАБОТА</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
              <th rowspan="2" width="20%"><div class="headTable">Наименование темы (раздела)</div></th>
              <th rowspan="2" width="65%"><div class="headTable">Форма (вид) самостоятельной работы</div></th>
              <th rowspan="2" width="10%"><div class="headTable">Трудоемкость в академических часах</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "work in z_indepWork">
              <td>{{z_indepWork.indexOf(work) + 1}}</td>
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.indep_work_name"></textarea></div></td>
              <td><vue-editor v-model="work.indep_content_old" :editor-toolbar="customContentToolbar"/></td>
              <td>{{work.indep_work}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="errors.length" class="ui error message" style="display: block">
        <div class="header">
          При формировании PDF могут возникнуть проблемы
        </div>
        <ul class="list">
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </div>
      <div class="ui bottom large attached button positive" tabindex="0" v-on:click="PushToController">
        Сохранить
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import { VueEditor } from "vue2-editor";
import competitionsMixin from "../mixins/competitionsMixin";
import dataMixin from "../mixins/dataMixin";
import dataRpdMixin from "../mixins/dataRpdMixin";
import computedMixin from "../mixins/computedMixin";
import tableOperationMixin from "../mixins/tableOperationMixin";
import getersMixin from "../mixins/getersMixin";
import StructSPO from "../components/struct_spo.vue";

export default {
  name: "create_rpd",
  mixins: [competitionsMixin, dataMixin, dataRpdMixin, computedMixin, tableOperationMixin, getersMixin],
  components: { VueEditor, StructSPO },
  data: () => ({
    programm: {edu_prog: 0, year: 0, edu_prof: 0, curriculum: 0, discipline: 0, rpd_sample: 0},
    ui_form_validate: {
      fields: {
        dep_manager: {
          identifier: 'dep_manager',
          rules: [
            {
              type: 'regExp',
              value: /^([А-ЯЁ][а-яё]+)\\s+([А-ЯЁ][а-яё]+)\\s+([А-ЯЁ][а-яё]+)$/,
              prompt: 'Укажите наименование показателя'
            }
          ]
        },
      }
    },

  }),
  computed: {

  },
  methods: {
    getMainInformation(edu_prog_id, edu_prof_id, curriculum_id, discipline_id) {
      if (discipline_id !== ""){
        axios({
          method: 'get',
          url: `/programms/get_main_info/${edu_prog_id}/${edu_prof_id}/${curriculum_id}/${discipline_id}`,
        }).then((response) => {
          this.main_info.discipline = response.data.discipline;
          this.main_info.speciality = response.data.speciality;
          this.main_info.speciality_code = response.data.speciality_code;
          if (this.no_profile.includes(edu_prog_id)) {
            this.main_info.profile = "";
          }
          else{
            this.main_info.profile = response.data.profile;
          }
          this.main_info.quality = this.basis_info[response.data.speciality_code].quality;
          this.main_info.year = response.data.year;
          this.main_info.edu_form = response.data.edu_form;
          this.overload = response.data.overload;
          this.main_info.creator.fio = response.data.fio;
          this.main_info.creator.position = response.data.position;
          this.main_info.creator.title = response.data.title;
          this.main_info.facility = response.data.facility;
          this.main_info.department = response.data.department;
          this.main_info.dep_manager = response.data.dep_manager;
          this.main_info.basis_num = this.basis_info[response.data.speciality_code].basis_num;
          this.main_info.basis_date = this.basis_info[response.data.speciality_code].basis_date;
          this.getControl();
          this.getTimes();
          this.main = true;
          this.aproval();
          this.basisText()
        }).catch((error) => {
          return error;
        });
      }
    },
    basisText(){
      if (this.main_info.speciality_code.split('.')[1] === '05'){
        this.main_info.basis = "Рабочая программа составлена на основании Федерального государственного образовательного стандарта ВО для специальности " + this.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
      }
      else if (this.main_info.speciality_code.length === 6 || this.main_info.speciality_code.length === 7){
        this.main_info.basis = "Рабочая программа составлена  на основании Федеральных государственных требований по научной специальности"
      }
      else if (this.main_info.speciality_code.split('.')[1] === '02'){
        this.main_info.basis = "Рабочая программа составлена на основании Федерального государственного образовательного стандарта среднего профессионального образования по специальности " + this.main_info.speciality + ", утвержденного приказом " + this.ministry[0]
      }
      else {
        this.main_info.basis = "Рабочая программа составлена на основании Федерального государственного образовательного стандарта ВО для направления подготовки " + this.main_info.speciality + ", утвержденного приказом " + this.ministry[0]
      }
    },
    getRPD(id) {
      if (id == 0 ){
        this.text_info = {purpose: "", task: "", place: "", technology: "", eval_tool: "", literature: "", mto: ""};
        this.software = [];
        this.resources = [];
        this.forms = [];
        this.data_bases = [];
        this.themes = [{
          num: 1,
          name: "",
          period: "",
          lecture: "",
          lecture_name: "",
          lecture_pp: "",
          practice: "",
          practice_name: "",
          practice_work: [],
          practice_pp: "",
          lesson_name: "",
          lesson: "",
          lesson_work: [],
          seminar_name: "",
          seminar: "",
          seminar_work: [],
          laboratory: "",
          laboratory_name: "",
          laboratory_pp: "",
          laboratory_work: [],
          ikr: "",
          kto: "",
          ke: "",
          control: "",
          indep_work: "",
          indep_work_name: "",
          control_form: "",
          lec_content_old: "",
          prac_content_old: "",
          lab_content_old: "",
          les_content_old: "",
          sem_content_old: "",
          indep_content_old: "",
          z_themes: false,
        }];
      }
      else {
        axios({
          method: 'get',
          url: `/programms/get_rpd/${id}`,
        }).then((response) => {
          this.text_info.purpose = response.data.rpd.purpose_old;
          this.text_info.task = response.data.rpd.tasks_old;
          this.text_info.place = response.data.rpd.discipline_place_old;
          this.text_info.technology = response.data.rpd.edu_tech_old;
          this.text_info.eval_tool = response.data.rpd.eval_tool_old;
          this.text_info.literature = response.data.rpd.literature_old;
          this.text_info.mto = response.data.rpd.structure_text_old;
          this.resources = response.data.rpd.resources;
          this.forms = response.data.rpd.forms;
          this.data_bases = response.data.rpd.data_bases;
          this.rpd_id = response.data.rpd.id;
          this.getThemes(id);
        }).catch((error) => {
          return error;
        });
      }
    },
    getThemes(id){
      axios({
        method: 'get',
        url: `/programms/get_themes/${id}`,
      }).then((response) => {
        this.themes = response.data.themes;
        this.themes.forEach(theme => {
          delete theme['id']
          delete theme['rpd_id']
        })
        this.sortThemes()
      }).catch((error) => {
        return error;
      });
    },
    getRPDSamples(){
      axios({
        method: 'get',
        url: `/programms/get_rpd_samples`,
      }).then((response) => {
        this.select_options.rpd_samples = response.data.samples
      }).catch((error) => {
        return error;
      });
    },
    genZPart(){
      let z_themes = []
      this.themes.forEach(theme => {
        const clone = JSON.parse(JSON.stringify(theme));
        clone.z_themes = true;
        delete clone['id']
        delete clone['rpd_id']
        delete clone['practice_work']
        delete clone['laboratory_work']
        delete clone['lecture_name']
        delete clone['lec_content_old']
        z_themes.push(clone);
      })
      this.themes = [...this.themes,...z_themes]
    },
    PushToController (){
      $(`.ui.form`).form(this.ui_form_validate);
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'post',
        url: '/programms/rpd',
        data: {
          data: {
            curriculum_id: this.programm.curriculum,
            discipline_id: this.programm.discipline,
            study_year_id: this.programm.year,
            educational_profile_id: this.programm.edu_prof,
            name: this.main_info.discipline,
            purpose_old: this.text_info.purpose,
            tasks_old: this.text_info.task,
            discipline_place_old: this.text_info.place,
            structure_text_old: this.text_info.mto,
            edu_tech_old: this.text_info.technology,
            eval_tool_old: this.text_info.eval_tool,
            literature_old: this.text_info.literature,
            competition: this.rpd_competitions,
            software: this.software,
            resources: this.resources,
            forms: this.forms,
            spo_comp: this.spo_comp,
            spo_controls: this.spo_controls,
            data_bases: this.data_bases,
            main_info: this.main_info,
            has_z_part: this.has_z_part,
          },
          themes: { dict: this.themes},
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204){
          location.assign("/programms/rpd")
        }
      }).catch((error) => {
        return error;
      });
    },
  },

  mounted() {
    this.getEduProg()
    this.getYears()
    this.getSoftware()
    this.getRPDSamples()
  }
}
</script>

<style scoped>
  .vueditor {
    width: 100px;
    height: 450px;
    height: 100%;
    border: 1px solid #ddd;
    background: #fff;
    box-sizing: border-box;
    position: relative;
  }

  .verticalText
  {
    text-align: center;
    vertical-align: middle;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    line-height: 1;
    width: 20px;
  }

  .headTable
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
  }

  .headTableInt
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
    word-wrap: break-word;
    width: 70px;
  }

  .invisible {
    visibility: hidden !important;
  }
</style>